import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { IsLoaderState } from '../interfaces/is-loader-state';

@Injectable({
	providedIn: 'root',
})
export class LoaderService {
	private readonly loaderState: WritableSignal<IsLoaderState> = signal<IsLoaderState>({
		isLoading: false,
		loadingMessage: '',
	});

	get loader(): Signal<IsLoaderState> {
		return this.loaderState;
	}

	public startLoading(message?: string): void {
		this.loaderState.set({
			isLoading: true,
			loadingMessage: message || '',
		});
	}

	public stopLoading(): void {
		this.loaderState.set({
			isLoading: false,
			loadingMessage: '',
		});
	}
}
